<template>
    <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div :class="sizeModal">
            <div class="modal-content" :style="style_content !== undefined ? style_content : ''">
                <div class="modal-header">
                    <slot name="breadcrumb"></slot>
                    <div class="modal-title w-100">
                        <h2 class="title--1" v-html="title"/>
                    </div>
                    <div class="modal__description">
                        <p 
                            v-if="message === undefined && isParentComponentUpdate" 
                            class="modal__description__text" 
                            v-html="update_default_message"
                        /> 
                        <p v-else class="modal__description__text" v-html="message"/>
                        <p v-if="link_message" class="modal__description__text mt-2" v-html="link_message" @click="link_event !== undefined && link_event ? linkEvent() : null"/>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()">
                      <img width="15px" src="/assets/img/svg/close.svg" alt="Imagen de una equis">
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="content"></slot>    
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    name: 'BaseModal',

    props: [
        'id',
        'title',
        'size',
        'message',
        'link_message',
        'link_event',
        'style_content',
    ],

    data() {
        return {
            update_default_message: `In this view, you can view and modify the details of your selected item. To edit a field, simply click on it, make your changes, and hit save.`
        }
    },

    methods: {

        linkEvent()
        {
            this.$emit('linkEvent', true)
        },

        close()
        {
            this.$emit('close', true)
        }
    },
    computed: 
    {
        parentComponentName() 
        {
            let parent = this.$parent
            while (parent) 
            {
                if (parent.$options.name) 
                {
                    return parent.$options.name
                }
                parent = parent.$parent
            }
            return 'Unknown'
        },

        isParentComponentUpdate() 
        {
            return this.parentComponentName.toLowerCase().includes('update')
        },

        sizeModal()
        {
            let modal_class = ''

            if(this.size == 'xl')
            {
                modal_class = 'modal-xl-dhk'
            }
            else if(this.size == 'lg')
            {
                modal_class = 'modal-lg-dhk'
            }
            else if(this.size == 'sm')
            {
                modal_class ='modal-sm modal-sm-dhk'
            }
            else
            {
                modal_class ='modal-md modal-md-dhk'
            }


            modal_class +=  ' modal-dialog modal-dialog-dhk'

            return modal_class
        }
  }

}

</script>